import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import palette from '@/theme/palette.ts';

export const IsActiveStatusChipCell = ({ status }: { status: string }) => {
  const { t } = useTranslation();
  const isActive = status === 'active';

  const mainColor = isActive ? palette.status.active.main : palette.status.inactive.main;
  const backgroundColor = isActive
    ? palette.status.active.background
    : palette.status.inactive.background;

  return (
    <Chip
      label={isActive ? t(`STATUS.ACTIVE`) : t(`STATUS.INACTIVE`)}
      variant="filled"
      sx={{
        color: mainColor,
        border: `1px solid ${mainColor}`,
        backgroundColor,
      }}
    />
  );
};
